import create from 'zustand';
import { UpdateABAPQueryState } from './interfaces/UpdateQueryState';
import { createCommonABAPQuerySlice } from './slices/ABAPQuerySlices/CommonABAPQuerySlice';
import { createUpdateABAPQuerySlice } from './slices/ABAPQuerySlices/UpdateABAPQuerySlice';

export const useUpdateABAPQueryStore = create<UpdateABAPQueryState>((set) => ({
  ...createCommonABAPQuerySlice(set),
  ...createUpdateABAPQuerySlice(set)
}));
